import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=738ad716&scoped=true"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=738ad716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ad716",
  null
  
)

export default component.exports